import { Http } from '@intelipost-js/secure-providers';

export default {
  getSkuGroups({ commit }) {
    commit('setLoading', true);

    Http.get('api/v1/client/sku_group')
      .then((res) => {
        commit('setSkuGroups', res.data.content);
        commit('setLoading', false);
      })
      .catch(() => commit('setLoading', false));
  },
};



// WEBPACK FOOTER //
// ./src/stores/sku-groups/actions.js